var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("SubHeaderItem", { staticClass: "actualites-page-title-content" }, [
        _c("p", {
          staticClass: "actualites-page-title",
          domProps: { innerHTML: _vm._s(_vm.$t("actualitesPage.encart-titre")) }
        }),
        _c("p", {
          staticClass: "actualites-page-texte",
          domProps: { innerHTML: _vm._s(_vm.$t("actualitesPage.encart-texte")) }
        })
      ]),
      _c(
        "PageView",
        {
          attrs: {
            mainTitle: _vm.$t("graePage.actualites.title"),
            noSubTitleExpected: true
          }
        },
        [
          _c("ContentView", { staticClass: "actualite-page" }, [
            _c("div", { staticClass: "actualites-page-content" }, [
              _c("div", { staticClass: "actualites-page-columns" }, [
                _c(
                  "div",
                  { staticClass: "actualites-page-column" },
                  [
                    _c("ActualitesCardsView", {
                      attrs: {
                        isLoadingData: _vm.isLoadingData,
                        title: _vm.$t("actualitesPage.activites-national"),
                        actualites: _vm.actualitesNat
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "actualites-page-column" },
                  [
                    _c("ActualitesCardsView", {
                      attrs: {
                        isLoadingData: _vm.isLoadingData,
                        title: _vm.$t("actualitesPage.activites-regional"),
                        actualites: _vm.actualitesReg
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "actualites-page-contact" },
                [_c("ContactCardsView", { attrs: { contact: _vm.contact } })],
                1
              )
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }